const API_ADD_USER_REQUEST = 'API_ADD_USER_REQUEST';
const API_ADD_USER_SUCCESS = 'API_ADD_USER_SUCCESS';
const API_ADD_USER_FAILURE = 'API_ADD_USER_FAILURE';
const RESET_ADD_USER_ERROR = 'RESET_ADD_USER_ERROR';

const GET_USERS_ROLLOUT_REQUEST = 'GET_USERS_ROLLOUT_REQUEST';
const GET_USERS_ROLLOUT_SUCCESS= 'GET_USERS_ROLLOUT_SUCCESS';
const GET_USERS_ROLLOUT_FAILURE = 'GET_USERS_ROLLOUT_FAILURE';

export const addUserRequest = () => ({
  type: API_ADD_USER_REQUEST,
});

export const addUserSuccess = payload => ({
  type: API_ADD_USER_SUCCESS,
  payload,
});

export const addUserFailure = payload => ({
  type: API_ADD_USER_FAILURE,
  payload,
});

export const getUserRolloutRequest = () => ({
  type: GET_USERS_ROLLOUT_REQUEST,
});

export const getUserRolloutSuccess = payload => ({
  type: GET_USERS_ROLLOUT_SUCCESS,
  payload,
});

export const getUserRolloutFailure = payload => ({
  type: GET_USERS_ROLLOUT_FAILURE,
  payload,
});

export const resetAddUserForm = () => ({
  type: RESET_ADD_USER_ERROR,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  report: null,
  users:[],
  isProgramCodeValid: false,
};

export function addUserReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_ADD_USER_ERROR:
      return {
        ...state,
        error: null,
      };
    case API_ADD_USER_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_ADD_USER_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        report: action.payload,
      };
    case API_ADD_USER_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        isFetched: true,
        report: null,
      };
      case GET_USERS_ROLLOUT_REQUEST:
        return {
          ...state,
          fetching: true,
        };
      case GET_USERS_ROLLOUT_SUCCESS:
        return {
          ...state,
          isFetched: true,
          fetching: false,
          users: action.payload.users,
        };
      case GET_USERS_ROLLOUT_FAILURE:
        return {
          ...state,
          fetching: false,
          error: action.payload,
          isFetched: true,
          report: null,
        };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/addUser.js